module.exports = __webpack_public_path__ + "img/login_tx@2x.7b998750.png";